import Logger from '@/js/logger';

function registerSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // navigator.serviceWorker.register('/cache-sw.js');
      })
      .catch((registrationError) => {
        Logger.error('SW registration failed: ', registrationError);
      });
  }
}

export function removeLoader() {
  setTimeout(function () {
    var loaderDivRe = document.querySelector('.preloader-container');
    if (loaderDivRe) loaderDivRe.parentNode.removeChild(loaderDivRe);
  }, 200);
  registerSW();
}

export function assignLanguageSelector() {
  const langSelector = document.querySelector('.button-language-container');
  if (!langSelector) return;

  langSelector.onmouseover = function () {
    langSelector.classList.add('hovering-list');
  };

  langSelector.onmouseout = function () {
    langSelector.classList.remove('hovering-list');
  };

  document.body.ontouchstart = function (e) {
    if (!langSelector.contains(e.target)) {
      langSelector.classList.remove('hovering-list');
    } else {
      langSelector.classList.add('hovering-list');
    }
  };
}

function isSameDay(t1, t2) {
  const d1 = new Date(t1);
  const d2 = new Date(t2);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

function closeNoticeBoard() {
  const notiContainer = document.querySelector('.announcement-container');
  if (notiContainer) {
    notiContainer.classList.remove('show');
    localStorage.setItem(process.env.ANNOUNCEMENT_CLOSE, Date.now());
  }
}

export function fetchServerNotice() {
  try {
    const notiContainer = document.querySelector('.announcement-container');
    if (!notiContainer) return;
    const hideNotiTimestamp = localStorage.getItem(
      process.env.ANNOUNCEMENT_CLOSE
    );
    const isHidden = hideNotiTimestamp
      ? isSameDay(Date.now(), parseInt(hideNotiTimestamp))
      : false;
    if (isHidden) return;
    const languageCode = document.documentElement.lang || 'en';

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status === 200) {
        try {
          var data = JSON.parse(this.responseText);
          const ret = data.filter((noti) => noti.language === languageCode);
          if (ret.length) {
            notiContainer.insertAdjacentHTML(
              'beforeend',
              '<table class="announcement-wrapper">' +
                ret
                  .map(
                    (el) =>
                      `<tr><td class="announcement-line"><div class="announcement-icon inline"></div><div class="announcement-content inline">${el.noti_content}</div></td></tr>`
                  )
                  .join('') +
                '</table>'
            );
            notiContainer.classList.add('show');
            const closeNoticeBtn = document.querySelector(
              '.btn-close-announcement'
            );
            if (closeNoticeBtn) closeNoticeBtn.onclick = closeNoticeBoard;
          }
        } catch (error) {
          Logger.error(error);
        }
      }
    };

    xhr.open(
      'GET',
      process.env.SOLLAE_API_URL +
        process.env.API_PREFIX +
        '/public/notifications?noti_state=1&active=true',
      true
    );
    xhr.send();
  } catch (err) {
    Logger.error(err);
  }
}
